import React from 'react';
import PropTypes from 'prop-types';
import { tns } from 'tiny-slider/src/tiny-slider';

class TinyCarousel extends React.PureComponent {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
        this.carousel = null;
    }

    componentDidMount() {
        this.createCarousel(this.rootRef.current);
    }

    componentDidUpdate(prevProps) {
        this.createCarousel(this.rootRef.current, this.props.slides === prevProps.slides);
    }

    componentWillUnmount() {
        if (this.carousel && typeof this.carousel.destroy === 'function') {
            this.carousel.destroy();
        }
    }

    createCarousel(container) {
        if (this.carousel) {
            this.carousel = this.carousel.rebuild();
            return;
        }

        this.carousel = tns({
            container,
            ...this.props.options,
        });
    }

    destroyCarousel = () => {
        if (this.carousel && typeof this.carousel.destroy === 'function') {
            this.carousel.destroy();
        }
    }

    render() {
        const { slides, rootCss } = this.props;

        if (slides.length === 0) {
            return null;
        }

        this.destroyCarousel();

        return (
            <div className={rootCss} ref={this.rootRef}>
                {this.props.children}
            </div>
        );
    }
}

TinyCarousel.defaultProps = {
    rootCss: null,
};

TinyCarousel.propTypes = {
    options: PropTypes.object,
    slides: PropTypes.array,
    rootCss: PropTypes.string,
};

export default TinyCarousel;
